import { Card, CardContent } from "../ui/card";
import { TestSubsection } from "./TestSection";
import { widgetJsQualityTests } from "./testDefinitions";

/**
 * Widget JS Quality Section - Tests for iOS Safari compatibility
 * CRITICAL: Tests the completeBooking function bug fix that caused production issues on iPhone
 */
export const WidgetJsQualitySection = ({ testResults }) => {
  return (
    <Card className="shadow-none mb-4 border-red-200">
      <CardContent className="pt-4">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs bg-red-100 text-red-700 px-2 py-0.5 rounded font-medium">CRITICAL</span>
          <span className="text-xs text-gray-500">iOS Safari Bug Fix Tests</span>
        </div>
        <TestSubsection 
          title="Widget JS Quality (iOS Safari)"
          tests={widgetJsQualityTests}
          results={testResults.widgetJsQuality}
        />
      </CardContent>
    </Card>
  );
};

export default WidgetJsQualitySection;
